<template>
  <section class="app__section__ernest">
    <v-progress-circular
      indeterminate
      color="valid"
      v-if="pageLoaded"
    />

    <section id="app__content" v-else>
      <section id="static__text__intro" v-html="staticText"></section>

      <v-card v-for="questionnaire in localQuestionnaires" :key="questionnaire.id">
        <section>
          <v-card-title>{{ questionnaire.label }}</v-card-title>
          <v-divider/>
          <v-card-text>
            {{ questionnaire.description }}
          </v-card-text>
          <v-divider v-if="!newPass(questionnaire)"/>
          <v-card-text v-if="!newPass(questionnaire)">
            <span class="card__line">Nb de passage</span> : {{ passNumber(questionnaire) }}<br/>
            <span class="card__line">Dernier passage</span> : {{ passLastDate(questionnaire) }}
          </v-card-text>
        </section>
        <footer>
          <v-divider/>
          <v-card-actions>
            <v-btn text @click="onClick(questionnaire)">{{ buttonLabel(questionnaire) }}</v-btn>
          </v-card-actions>
          <v-divider v-if="haveOneIteration(questionnaire)"/>
          <v-card-actions v-if="haveOneIteration(questionnaire)">
            <router-link :to="{name: 'user_results', params: { id: questionnaire.id }}">
              <v-btn text>Voir mes résultats</v-btn>
            </router-link>
          </v-card-actions>
        </footer>
      </v-card>

      <v-dialog
        v-model="dialog.display"
        max-width="500"
      >
        <v-card>
          <v-card-title class="headline">Recommencer le questionnaire</v-card-title>

          <v-card-text>
            Souhaitez vous continuer le questionnaire où vous l'aviez laissé ?<br/>
            Ou souhaitez-vous le recommencer depuis le début ?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="cancel"
              @click="deleteIteration(dialog.questionnaireSelected)"
            >
              Depuis le début
            </v-btn>

            <v-btn
              color="valid"
              @click="$router.push({
              name: 'userQuestionnairePass',
              params: { id: dialog.questionnaireSelected.id }
            })"
            >
              À la dernière sauvegarde
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </section>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Home',
  data () {
    return {
      dialog: {
        display: false,
        questionnaireSelected: null
      },
      localQuestionnaires: [],
      loaded: false,
      staticText: ''
    }
  },
  computed: {
    ...mapGetters('Questionnaires', [
      'questionnaires'
    ]),
    ...mapGetters('UserQuestionnaire', [
      'userQuestionnaires'
    ]),
    ...mapGetters('User', [
      'user'
    ]),
    pageLoaded () {
      return !this.loaded
    }
  },
  async created () {
    await this.axios({
      method: 'GET',
      url: 'statictexts/utilisateur_liste_des_questionnaires/'
    })
      .then(response => {
        this.staticText = response.data.text
      })

    await this.loadUser()

    await this.loadUserQuestionnaires()
    this.localQuestionnaires = [].concat(this.userQuestionnaires)
    this.loaded = true
  },
  methods: {
    ...mapActions('Questionnaires', [
      'loadQuestionnaires'
    ]),
    ...mapActions('UserQuestionnaire', [
      'deleteIteration',
      'loadUserQuestionnaires'
    ]),
    ...mapActions('User', [
      'loadUser'
    ]),
    buttonLabel (questionnaire) {
      return questionnaire.iterations.length === 0
        ? this.$t('appUser.questionnairesList.buttons.pass.name')
        : questionnaire.iterations[questionnaire.iterations.length - 1].finishedAt === null
          ? this.$t('appUser.questionnairesList.buttons.continue.name')
          : this.$t('appUser.questionnairesList.buttons.repass.name')
    },
    haveOneIteration (questionnaire) {
      return this.returnLastIteration(questionnaire) !== undefined
    },
    /**
     * Retourne faux s'il n'y a pas d'itération ou s'il n'y a pas d'itération notée terminée.
     *
     * @param questionnaire
     * @return {boolean}
     */
    newPass (questionnaire) {
      return questionnaire.iterations.length === 0 ||
        this.returnLastIteration(questionnaire) === undefined
    },
    /**
     * Lancée lorsque l'utilisateur clique sur les boutons :
     * - Commencer le questionnaire
     * - Continuer le questionnaire
     * - Recommencer le questionnaire
     * Affiche la fenêtre de dialogue lorsque le questionnaire est recommencé.
     *
     * @param questionnaire
     */
    onClick (questionnaire) {
      if (questionnaire !== undefined) {
        this.dialog.questionnaireSelected = questionnaire
        if (questionnaire.iterations.length === 0) {
          this.$router.push({
            name: 'userQuestionnairePass',
            params: { id: questionnaire.id }
          })
        } else if (questionnaire.iterations[questionnaire.iterations.length - 1].finishedAt === null) {
          this.dialog.questionnaireSelected = questionnaire
          this.dialog.display = true
        } else {
          this.$router.push({
            name: 'userQuestionnairePass',
            params: { id: questionnaire.id }
          })
        }
      }
    },
    /**
     * Retourne le nombre d'itération terminée ou null s'il n'y a pas d'itération terminée.
     * @param questionnaire
     * @return {Number|null}
     */
    passNumber (questionnaire) {
      return this.returnLastIteration(questionnaire) !== undefined
        ? this.returnLastIteration(questionnaire).number
        : null
    },
    /**
     * Retourne la date de la dernière itération terminée ou null s'il n'y a pas d'itération terminée.
     * @param questionnaire
     * @return {String|null}
     */
    passLastDate (questionnaire) {
      return this.returnLastIteration(questionnaire) !== undefined
        ? (new Date(this.returnLastIteration(questionnaire).finishedAt))
          .toLocaleString(navigator.language)
        : null
    },
    /**
     * Transformation de l'objet au départ en string pour éviter que lors du reverse,
     * VueJs ne recharge le composant car il détecte un changement du tableau et lance une boucle
     * infinie.
     *
     * @param questionnaire
     * @return {IterationAir | undefined}
     */
    returnLastIteration (questionnaire) {
      return JSON.parse(JSON.stringify(questionnaire.iterations))
        .reverse()
        .find(iteration => {
          return iteration.finishedAt !== null
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/styleAppErnest";
  @import "../../../assets/style/colors";
  @import "../../../assets/style/responsive";

  .app__section__ernest {
    display: flex;
    justify-content: center;
    align-items: center;

    #app__content {
      display: grid;
      grid-gap: 30px;
      grid-template-columns: repeat(4, 1fr);

      #static__text__intro {
        grid-column: 1/5;

        @media all and (max-width: $large) and (min-width: $medium) {
          grid-column: 1/4;
        }

        @media all and (max-width: $medium) {
          grid-column: 1/2;
        }
      }

      @media all and (max-width: $large) and (min-width: $medium) {
        grid-template-columns: repeat(3, 1fr);
      }

      @media all and (max-width: $medium) {
        grid-template-columns: repeat(1, 1fr);
      }

      .v-card {
        border-radius: 0;
        box-shadow: none;
        border: 1px solid $borderCard;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        hr {
          margin: 0;
          visibility: visible;
        }
      }

      .v-card__text:nth-child(3) {
        font-size: 1rem;
      }

      .v-card__text:nth-child(5) {
        padding: 5px 10px;

        .card__line {
          text-decoration: underline;
          font-size: 0.875rem;
          color: rgba(0, 0, 0, 0.54)
        }
      }

      .v-card__actions {
        display: flex;
        justify-content: center;

        a {
          text-decoration: none;
        }
      }
    }
  }
</style>
